import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueQrcodeReader from 'vue-qrcode-reader';
import Toasted from 'vue-toasted';
import '@/components/_globals';
import router from '@/router';
import store from '@/store/store';
import i18n from './i18n';
import App from './App.vue';

import './registerServiceWorker';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

// Bugsnag - START
if (process.env.VUE_APP_BUGSNAG_API_KEY) {
  Bugsnag.start({
    apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()]
  });

  Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
}
// Bugsnag - END

Vue.use(require('vue-moment'));

Vue.use(Vue2TouchEvents);
Vue.use(VueQrcodeReader);
Vue.use(Toasted, {
  position: 'bottom-center',
  duration: 3000,
  singleton: true,
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
